import systemApi from './../../api/system.js';
import userDataApi from './../../api/userData.js';
import toastr from 'toastr';
import i18n from '@/i18n.bootstrap';
import projectsApi from "@/api/projects";

export default {
    loadGlobalConfiguration: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            let currentVersion = localStorage.getItem('colab-version');
            
            systemApi.loadGlobalConfiguration().then(
                response => {
                    commit('setGlobalConfiguration', response.data);
                    
                    let newVersion = response.data.appVersion; 
                    localStorage.setItem('colab-version', newVersion);
                    
                    if (currentVersion && currentVersion != newVersion) {
                        dispatch('setUIReload', 'RELOAD');
                    }

                    resolve(response.data);
                },
                error => {
                    console.log('loadGlobalConfiguration error', { ...error });
                    reject(error);
                }
            );
        });
    },

    loadInputLimits: ({ commit }) => {
        return new Promise((resolve, reject) => {
            systemApi.loadInputLimits()
                .then(response => {
                    commit('setInputLimits', response.data);
                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    },

    loadSignedInUsersCount: ({ commit }) => {
        userDataApi.loadSignedInUsersCount().then(
            response => {
                commit('setSignedInUsersCount', response.data);
            },
            error => {
                console.log('loadSignedInUsersCount error', { ...error });
            }
        );
    },

    // eslint-disable-next-line
    inviteParticipants: ({ commit }, invitations) => {
        return new Promise((resolve, reject) => {
            systemApi.inviteParticipants(invitations).then(
                response => {
                    if(response) {
                        toastr.success(i18n.t('project.settings.participants.inviteDlg.action.info'));
                        resolve(response);
                    }
                },
                error => {
                    if (error.response.data.type === 'INVITATION_INVALID') {
                        toastr.error(i18n.t('project.settings.participants.inviteDlg.action.errorInvalidInvitation'));
                    }else if(error.response.data[0].message === 'INVALID_EMAIL_FORMAT'){
                        toastr.error(i18n.t('project.invitation.action.INVALID_EMAIL_FORMAT'));
                    }else {
                        toastr.error(i18n.t('project.settings.participants.inviteDlg.action.error'));
                    }
                    console.log('inviteParticipant error', { ...error });
                    reject(error);
                }
            );
        });
    },

    loadInviteInfo: ({ commit }, inviteId) => {
        return new Promise((resolve, reject) => {
            systemApi.loadInviteInfo(inviteId).then(
                response => {
                    commit('setInviteInfo', response.data);
                    resolve(response);
                },
                error => {
                    toastr.error(i18n.t('project.invitation.action.errorLoading'));
                    console.log('loadInviteInfo error', { ...error });
                    reject(error);
                }
            );
        });
    },

    setInvite: ({ commit }, invite) => {
        // setInvite is used to mark that the user is coming from the invite component in case he has to log in
        commit('setInvite', invite);
        // this.$cookie.set('EPR_INVITE', invite, 1);
    },

    // eslint-disable-next-line
    redeemInvite: ({ commit }, invite) => {
        return new Promise((resolve, reject) => {
            systemApi.redeemInvite(invite).then(
                () => {
                    //$router.push('/');
                    resolve();
                },
                error => {
                    if (error.response.data.type === 'INVITATION_EXPIRED') {
                        toastr.warning(
                            i18n.t('project.invitation.action.errorRedeemingExpired'),
                            error.response.data.message
                        );
                    } else if (error.response.data.type === 'INVITATION_INVALID') {
                        toastr.warning(
                            i18n.t('project.invitation.action.errorRedeemingInvalid'),
                            error.response.data.message
                        );
                    } else {
                        toastr.error(i18n.t('project.invitation.action.errorRedeeming'));
                        console.log('setInvite error', { ...error });
                    }
                    reject(error);
                }
            );
        });
    },

    // eslint-disable-next-line
    doFormLogin: ({ commit }, { creds }) => {
        return new Promise((resolve, reject) => {
            systemApi.doFormLogin(creds)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                }
            );
        });
    },

    setLoadingStatus: ({ commit }, status) => {
        commit('setLoadingStatus', status);
    },
    
    setDownloadingStatus: ({ commit }, status) => {
        commit('setDownloadingStatus', status);
    },

    setRedirectInfo: ({ commit }, redirect) => {
        commit('setRedirectInfo', redirect);
    },

    setUIReload: ({ commit }, reload) => {
        commit('setUIReload', reload);
    },

    resetStoreModuleData: ({ commit }) => {
        commit('resetStoreModuleData');
    },

    deleteRole: ({ commit }, roleId) => {
        return systemApi.deleteRole(roleId).then(
            () => {
                toastr.success(i18n.t('admin.settings.rolesManagement.successDeleteRole'));
                commit('deleteRole', roleId);
            },
            error => {
                if (error.response.data[0].message === 'ROLE_IN_USE') {
                    toastr.error(i18n.t('admin.settings.rolesManagement.ROLE_IN_USE'));
                    console.log('deleteRole error', {...error});
                    reject(error);
                }else {
                    toastr.error(i18n.t('admin.settings.rolesManagement.errorDeleteRole'));
                    console.log('createRole error', {...error});
                    reject(error);
                }
            }

        );
    },

    loadRoles: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {

            systemApi.loadRoles().then(
                response => {
                    commit('setRoles', response.data);

                    resolve(response.data);
                },
                error => {
                    console.log('loadRoles error', { ...error });
                    reject(error);
                }
            );
        });
    },

    createRole: ({ commit }, { role }) => {
        return new Promise((resolve, reject) => {
            systemApi.createRole(role).then(
                response => {
                    toastr.success(i18n.t('admin.settings.rolesManagement.successCreateRole'));
                    commit('createRole', response.data);
                    resolve(response);
                },
                error => {
                    if (error.response.data[0].message === 'NAME_TAKEN'){
                        toastr.error(i18n.t('admin.settings.rolesManagement.NAME_TAKEN'));
                        console.log('createRole error', { ...error });
                        reject(error);
                    } else {
                        toastr.error(i18n.t('admin.settings.rolesManagement.errorCreateRole'));
                        console.log('createRole error', {...error});
                        reject(error);
                    }
                }
            );
        });
    },

    markJob: ({ commit }) => {
        return new Promise((resolve, reject) => {
            systemApi.markJob().then(
                response => {
                    toastr.success(i18n.t('admin.settings.jobs.successMarkJob'));
                    resolve(response);
                },
                error => {
                    toastr.error(i18n.t('admin.settings.jobs.errorMarkJob'));
                    console.log('markJob error', {...error});
                    reject(error);
                }
            );
        })
    },
};
